module.exports = __webpack_public_path__ + "static/img/13.2282a7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/13.png
// module id = kU4N
// module chunks = 0